export default [
  {
    sectionTitle: 'Gestão de cadastros',
    sectionSubtitle:
      'Essa sessão fala sobre os cadastros realizados no clube pelos seus consumidores. Lembre-se sempre que o seu filiado só tem acesso aos cadastros que realizaram compras em alguma de suas lojas',
    cards: [
      {
        title: 'Edição de cadastros',
        subtitle: `Ativar essa opção da ao filiado a possibilidade de editar qualquer dados de cadastro dos consumidores cadastrados no clube
        que já compraram em alguma das loja desse associado.`,
        permission: 'edit_user_register',
      },
    ],
  },
  {
    sectionTitle: 'Gestão de saldo e carteira',
    sectionSubtitle:
      'O saldo é fruto dos beneficios do clube, tais quais campanhas de pontos e cashback, ou ajustes realizados pela plataforma. O saldo dos consumidores do clube da sua rede pode ser utilizado na loja de qualquer dos seus filiados.',
    cards: [
      {
        title: 'Edição de saldo de cashback',
        subtitle: 'Tendo essa possibilidade o filiado pode tanto remover quanto creditar saldo de cashback para um consumidor de suas lojas',
        permission: 'edit_cashback',
        module: 'cashback',
      },
      {
        title: 'Edição de saldo de pontos',
        subtitle: 'Tendo essa possibilidade o filiado pode tanto remover quanto creditar saldo de pontos para um consumidor de suas lojas',
        permission: 'edit_points',
        module: 'points',
      },
    ],
  },
]
